import styled from 'styled-components'
import { getStepperContainerStyles } from '../style'

const StyledStepperContainer = styled.div(({ theme }) =>
    getStepperContainerStyles({ theme })
)

export default StyledStepperContainer
